import { useMemo } from 'react'
import { useIsSendByRelayer } from './useIsSendByRelayer'
import { useSpotSwapPair } from '~/state/dex/hooks'
import { formatUnits } from 'viem'

export const useSettlementFeeValidator = (minAmountOut: bigint = 0n) => {
  const [, outputToken] = useSpotSwapPair()
  const isSendByRelayer = useIsSendByRelayer()

  const isValid = useMemo(() => {
    if (!isSendByRelayer || !minAmountOut) return true

    const receivedAmount = formatUnits(minAmountOut, outputToken?.decimals)
    if (Number(receivedAmount) <= 0) {
      return false
    } else {
      return true
    }
  }, [minAmountOut, isSendByRelayer, outputToken?.decimals])

  return isValid
}
